<template>
  <notification icon="fa-at" type="is-info" @delete="$emit('delete')">
    <div>
      <p>
        Wiadomość została wysłana na adres
        <strong>{{ mailAddress }}</strong
        >. Sprawdź swoją skrzynkę pocztową.
      </p>
      <p>
        <button
          class="button is-primary is-small is-pulled-right"
          @click="sendAgain"
        >
          <icon name="fa-undo" />
          <span>Wyślij ponownie</span>
        </button>
      </p>
    </div>
  </notification>
</template>

<script>
import { Notification } from "%notifications";
import { Icon } from "%helpers";

export default {
  name: "exchange-token-sent-notification",

  components: {
    Notification,
    Icon
  },

  props: {
    mailAddress: String,
    sendAgain: Function
  }
};
</script>

<style lang="scss" scoped>
.button {
  margin-top: 0.5rem;
}
</style>
